<template>
  <v-card flat>
    <v-card-text>
      <v-row class="py-0">
        <v-col cols="12" md="6" class="py-0">
          <v-row class="py-1">
            <v-col sm="12" class="py-0">
              <v-expansion-panels focusable>
                <v-expansion-panel>
                  <v-expansion-panel-header>Import References</v-expansion-panel-header>
                  <v-expansion-panel-content class="pt-2">
                    <div class="d-flex">
                      <v-card elevation="0" width="60%">
                        <v-file-input
                          v-model="ref_file"
                          label="File input"
                          class="mx-1"
                          outlined
                          dense
                        />
                        <div class="d-flex align-stretch">
                          <v-btn
                            elevation="0"
                            color="primary"
                            @click="uploadReferencesData"
                          >
                            Upload
                          </v-btn>
                          <v-alert
                            v-if="ref_answer"
                            :icon="false"
                            :type="ref_answer.type"
                            dense
                            max-height="36"
                            class="ml-4"
                          >
                            {{ ref_answer.data }}
                          </v-alert>
                        </div>
                      </v-card>
                    </div>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" md="6" class="py-0">
          <v-row class="py-1">
            <v-col sm="12" class="py-0">
              <v-expansion-panels focusable>
                <v-expansion-panel>
                  <v-expansion-panel-header>Import Report</v-expansion-panel-header>
                  <v-expansion-panel-content class="pt-2">
                    <div class="d-flex">
                      <v-card elevation="0" width="60%">
                        <v-file-input
                          v-model="rep_file"
                          label="File input"
                          class="mx-1"
                          outlined
                          dense
                        />
                        <div class="d-flex align-stretch">
                          <v-btn
                            elevation="0"
                            color="primary"
                            @click="uploadReportData"
                          >
                            Upload
                          </v-btn>
                          <v-alert
                            v-if="rep_answer"
                            :icon="false"
                            :type="rep_answer.type"
                            dense
                            max-height="36"
                            class="ml-4"
                          >
                            {{ rep_answer.data }}
                          </v-alert>
                        </div>
                      </v-card>
                    </div>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  data: () => ({
    ref_file: null,
    ref_answer: null,
    rep_file: null,
    rep_answer: null
  }),
  methods: {
    async uploadReferencesData() {
      this.ref_answer = {"type":"info", "data": "File sent"};
      const formData = new FormData();
      formData.set('file', this.ref_file);

      const xhr = new XMLHttpRequest();
      xhr.open("POST", "/api/import-references");
      xhr.seenBytes = 0;

      xhr.upload.onprogress = (event) => {
        this.ref_answer = {"type":"info", "data": "Upload to server " + + event.loaded + ' byte from ' + event.total}
      }

       xhr.upload.onerror = function() {
        this.ref_answer = {"type":"error", "data": "Error"}
      }

      xhr.onreadystatechange = () => {
        if(xhr.readyState > 2) {
          if (xhr.seenBytes < xhr.responseText.length) {
            let answerParts = xhr.responseText.substr(xhr.seenBytes).split('\n');
            this.ref_answer = JSON.parse(answerParts[answerParts.length - 1]);
            xhr.seenBytes = xhr.responseText.length;
          }
        }
      }
      xhr.send(formData);
    },
    async uploadReportData() {
      this.rep_answer = {"type":"info", "data": "File sent"};
      const formData = new FormData();
      formData.set('file', this.rep_file);

      const xhr = new XMLHttpRequest();
      xhr.open("POST", "/api/import-report");
      xhr.upload.onprogress = (event) => {
        this.req_answer = {"type":"info", "data": "Upload to server " + + event.loaded + ' byte from ' + event.total}
      }

      xhr.upload.onerror = function() {
        this.req_answer = {"type":"error", "data": "Error"}
      }

      xhr.seenBytes = 0;

      xhr.onreadystatechange = () => {
        if(xhr.readyState > 2) {
          if (xhr.seenBytes < xhr.responseText.length) {
            let answerParts = xhr.responseText.substr(xhr.seenBytes).split('\n');
            this.rep_answer = JSON.parse(answerParts[answerParts.length - 1]);
            xhr.seenBytes = xhr.responseText.length;
          }
        }
      }
      xhr.send(formData);
    }
  },
  watch: {
    ref_file() {
      this.ref_answer = null;
    },
    rep_file() {
      this.rep_answer = null;
    }
  },
}
</script>